<template>
  <div id="printReport">
    <div class="row">
      <div class="col-sm-2">
        <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
      </div>
      <div class="col-sm-10">
        <h3 class="text-center">Relatório de Contemplação</h3>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-sm-12">
        <div class="panel panel-defaul">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-3">
                <label>Administradora</label>
                <br />
                {{ (form.administrator_id == null || form.administrator_id == '') ? 'Todas' : administrator }}
              </div>
              <div class="col-md-3">
                <label>Equipe</label>
                <br />
                {{ form.team_id == null ? 'Todas' : team }}
              </div>
              <div class="col-md-3">
                <label>Vendedor</label>
                <br />
                {{ form.salesman_id == null ? 'Todos' : salesman }}
              </div>
              <div class="col-md-3">
                <label>Intervalo</label>
                <br />
                {{ init_at | moment('DD/MM/YYYY') }} à {{ end_at | moment('DD/MM/YYYY') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-for="iterator in report" v-show="iterator.proposals.length > 0">
      <div id="conteudo" class="col-md-12">
        <div class="row">
          <b>Administratora: {{ iterator.name }}</b>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="panel panel-defaul">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-12">
                    <table id="tabela" class="table b-table table-sm generate-excel">
                      <thead class="thead-dark">
                        <tr>
                          <th class="text-center">Vendedor</th>
                          <th class="text-center">Mês</th>
                          <th class="text-center">Nº Contrato</th>
                          <th class="text-center">Nome Cliente</th>
                          <th class="text-center">CPF/CNPJ Cliente</th>
                          <th class="text-center">Data Contemplação</th>
                          <th class="text-center">Tipo Contemplação</th>
                          <th class="text-center">Efetuou o pagamento do boleto</th>
                          <th class="text-center">Valor do Crédito</th>
                          <th class="text-center">Tel. Celular</th>
                          <th class="text-center">Tel. Residencial</th>
                          <th class="text-center hide">Administradora</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="proposal in iterator.proposals">
                          <td>{{ proposal.salesman }}</td>
                          <td class="text-center">{{ proposal.contemplate_at | moment('MM') }}</td>
                          <td class="text-center">{{ proposal.physical_proposal }}</td>
                          <td>{{ proposal.client }}</td>
                          <td class="text-center">{{ proposal.cpf_cnpj | cpf_cnpj }}</td>
                          <td class="text-center">{{ proposal.contemplate_at | moment('DD/MM/YYYY') }}</td>
                          <td class="text-center">{{ proposal.type_contemplation == 'L' ? 'Lance' : 'Sorteio' }}</td>
                          <td class="text-center">{{ proposal.paid_billet ? 'Sim' : 'Não' }}</td>
                          <td class="text-center">R${{ proposal.value | price }}</td>
                          <td class="text-center">{{ proposal.cell_phone | phone  }}</td>
                          <td class="text-center">{{ proposal.home_phone | phone  }}</td>
                          <td class="text-center hide">{{ iterator.name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row dont-print">
      <div class="col-md-12 text-center">
        <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
        <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
        <button type="button" @click="pdf()" class="btn btn-fill btn-info">PDF</button>
        <button type="button" @click="excel()" class="btn btn-fill btn-success">Excel</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    administrators: {
      get() {
        return this.$store.state.administrators.itens;
      }
    },
    end_at() {
      if (this.form.date_at == undefined) {
        return new Date();
      }

      return this.form.date_at[1];
    },
    init_at() {
      if (this.form.date_at == undefined) {
        return new Date();
      }
      
      return this.form.date_at[0];
    },
    report: {
      get() {
        return this.$store.state.reports.item;
      }
    },
    teams: {
      get() {
        return this.$store.state.teams.itens;
      }
    },
  },
  data() {
    return {
      administrator: '',
      form: {},
      team: '',
      salesman: '',
    };
  },
  methods: {
    close() {
      window.opener.focus();
      window.close();
    },
    async getDataAdministrators() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("administrators/all");

      response.then(function(_administrators) {
        var administrator = _administrators.find(
          administrator => administrator.id === self.form.administrator_id
        );
        if (administrator !== undefined) {
          self.administrator = administrator.name;
        }
        self.$root.$emit("onLoading");
        self.getDataTeams();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getDataTeams();
      });
    },
    async getDataReport() {
      var self = this;

      self.$root.$emit("onLoading");
      const response = self.$store.dispatch(
        "reports/commissionContemplation",
        self.form
      );

      response.then(function() {
        self.$root.$emit("onLoading");
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    async getDataTeams() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch("teams/all");

      response.then(function(_teams) {
        var team = _teams.find(team => team.id === self.form.team_id);
        if (team !== undefined) {
          self.team = team.name;
          var salesman = team.salesmans.find(salesman => salesman.id === self.form.salesman_id);
          if (salesman !== undefined) {
            self.salesman = salesman.name
          }
        }
        self.$root.$emit("onLoading");
        self.getDataReport();
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
        self.getDataReport();
      });
    },
		excel() {
      var tabelas = document.querySelectorAll('.generate-excel');

      var tabelaCombinada = document.createElement('table');
      tabelaCombinada.className = 'table b-table table-sm table-combined';
      var thead = tabelaCombinada.createTHead();
      var tbody = document.createElement('tbody');

      var primeiroCabecalho = tabelas[0].querySelector('thead').cloneNode(true);
      thead.appendChild(primeiroCabecalho);

      tabelas.forEach(function(tabela) {
          var linhas = tabela.querySelectorAll('tbody tr');
          linhas.forEach(function(linha) {
              tbody.appendChild(linha.cloneNode(true));
          });
      });

      tabelaCombinada.appendChild(tbody);

			var nome = "RELATÓRIO DE CONTEMPLAÇÃO";
			var htmlPlanilha =
					'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
					nome +
					"</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
					nome +
					"</title></head><body><table>" +
            tabelaCombinada.innerHTML +
					"</table>";
			var htmlBase64 = btoa(htmlPlanilha);
			var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
			var hyperlink = document.createElement("a");
			hyperlink.download = "Relatório de Contemplação";
			hyperlink.href = link;
			hyperlink.style.display = "none";
			document.body.appendChild(hyperlink);
			hyperlink.click();
			document.body.removeChild(hyperlink);
		},
    pdf() {
      var self = this;

      self.$root.$emit("onLoading");

      const response = self.$store.dispatch(
        "reports/commissionContemplationInPdf",
        self.form
      )

      response.then(function(_downloadPdf) {
          let filename = 'contemplations.pdf'
          let blob = new Blob([_downloadPdf], {type: 'application/pdf'});

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click();

          self.$root.$emit("onLoading")
      });

      response.catch(function() {
        self.$root.$emit("onLoading");
      });
    },
    print() {
      window.print();
    },
  },
  mounted() {
    var self = this;

    self.form = JSON.parse(self.$route.query.form);

    self.getDataAdministrators();
  }
};
</script>
<style type="scss">
@media print {
  .page{
    margin: 5%;
  }
  .dont-print {
    display: none;
  }
  .table{
    width: 80%;
  }
  .table .thead-dark th {
    color: #aaaaaa;
  }
  .panel-danger {
    border-color: #ebccd1;
    width: 93%;
    margin-left: 4%;
}
}
</style>